// extracted by mini-css-extract-plugin
export default {"tabs":"timesheet_tabs__71eII","tab-button":"timesheet_tab-button__5Favj","active":"timesheet_active__6SK-D","completed":"timesheet_completed__4c1j+"};